import { SVGPropsIcon } from 'src/types';

export const Gobelet = (props: SVGPropsIcon) => (
  <svg
    {...props}
    width="30"
    height="29"
    viewBox="0 0 30 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
    onClick={props.onClick}>
    <path
      d="M23.1713 4.81375H6.65473C6.65473 4.81375 6.46103 19.7821 14.6924 20.182V20.1902C14.7671 20.1902 14.8403 20.1902 14.9134 20.1902C14.9866 20.1902 15.0605 20.1902 15.1353 20.1902V20.182C23.365 19.7821 23.1713 4.81375 23.1713 4.81375Z"
      fill="#FFD13D"
    />
    <path
      d="M23.1713 4.81375H18.7401C18.7217 6.64646 18.3567 17.6007 12.3759 19.6123C13.1039 19.9553 13.8903 20.1488 14.6908 20.182V20.1902C14.7655 20.1902 14.8387 20.1902 14.9118 20.1902C14.985 20.1902 15.0589 20.1902 15.1336 20.1902V20.182C23.365 19.7821 23.1713 4.81375 23.1713 4.81375Z"
      fill="#FCAF00"
    />
    <path
      d="M19.6942 17.059L19.3357 16.2297C19.4097 16.1959 26.7304 12.8206 26.0721 9.01423C25.9354 8.21865 25.6453 7.73719 25.2104 7.58302C24.1093 7.19224 22.1103 8.71001 21.4979 9.2731L20.9079 8.59707C21.1892 8.33902 23.7106 6.09079 25.499 6.72643C26.2602 6.99602 26.7456 7.71575 26.9458 8.85594C27.7166 13.359 20.0213 16.9098 19.6942 17.059Z"
      fill="#FCAF00"
    />
    <path
      d="M10.3038 17.059C9.97589 16.9098 2.28065 13.359 3.05467 8.85594C3.25159 7.71328 3.73707 6.99602 4.50145 6.72643C6.29063 6.09079 8.81123 8.33902 9.09255 8.59707L8.50339 9.2731C7.84511 8.67044 5.89437 7.19059 4.79 7.58302C4.35516 7.73801 4.06661 8.21948 3.92917 9.01423C3.2741 12.8206 10.5908 16.1959 10.6647 16.2297L10.3038 17.059Z"
      fill="#FFD13D"
    />
    <path
      d="M22.9704 4.89619H6.85567C6.61053 4.89619 6.37542 4.79631 6.20208 4.6185C6.02873 4.4407 5.93135 4.19955 5.93135 3.9481C5.93135 3.69665 6.02873 3.45549 6.20208 3.27769C6.37542 3.09989 6.61053 3 6.85567 3H22.9704C23.2155 3 23.4506 3.09989 23.624 3.27769C23.7973 3.45549 23.8947 3.69665 23.8947 3.9481C23.8947 4.19955 23.7973 4.4407 23.624 4.6185C23.4506 4.79631 23.2155 4.89619 22.9704 4.89619Z"
      fill="#FFD527"
    />
    <path
      d="M15.8972 19.5249C15.8972 19.5249 16.3835 25.6257 19.3349 26H14.9142V19.5694L15.8972 19.5249Z"
      fill="#FCAF00"
    />
    <path
      d="M15.8972 19.5249C15.8972 19.5249 16.3835 25.6257 19.3349 26H14.9142V19.5694L15.8972 19.5249Z"
      fill="#FFD13D"
    />
    <path
      d="M13.92 19.5249C13.92 19.5249 13.4377 25.6257 10.4823 26H14.903V19.5694L13.92 19.5249Z"
      fill="#FCAF00"
    />
    <path
      d="M9.46952 26C9.46952 25.5736 9.63465 25.1647 9.92858 24.8632C10.2225 24.5617 10.6212 24.3924 11.0369 24.3924H18.7731C19.1888 24.3924 19.5874 24.5617 19.8814 24.8632C20.1753 25.1647 20.3404 25.5736 20.3404 26H9.46952Z"
      fill="#FED03A"
    />
    <path
      d="M13.7672 24.8458C13.7672 25.0395 13.068 25.1962 12.2055 25.1962C11.3431 25.1962 10.643 25.0395 10.643 24.8458C10.643 24.6521 11.3431 24.4962 12.2055 24.4962C13.068 24.4962 13.7672 24.6529 13.7672 24.8458Z"
      fill="#FEF68E"
    />
    <path
      d="M9.46952 10.5427C10.514 10.5427 11.3608 9.4354 11.3608 8.06943C11.3608 6.70347 10.514 5.59614 9.46952 5.59614C8.425 5.59614 7.57826 6.70347 7.57826 8.06943C7.57826 9.4354 8.425 10.5427 9.46952 10.5427Z"
      fill="#FEF68E"
    />
    <path
      d="M8.74934 4.11298C9.79519 4.11298 10.643 3.90074 10.643 3.63893C10.643 3.37713 9.79519 3.16489 8.74934 3.16489C7.7035 3.16489 6.85567 3.37713 6.85567 3.63893C6.85567 3.90074 7.7035 4.11298 8.74934 4.11298Z"
      fill="#FEF68E"
    />
    <path
      d="M12.1428 4.11298C12.6658 4.11298 13.0897 3.90074 13.0897 3.63893C13.0897 3.37713 12.6658 3.16489 12.1428 3.16489C11.6199 3.16489 11.196 3.37713 11.196 3.63893C11.196 3.90074 11.6199 4.11298 12.1428 4.11298Z"
      fill="#FEF68E"
    />
    <path
      d="M14.9311 7.10814L15.7791 8.8716L17.6768 9.15439C17.6804 9.15499 17.6838 9.1566 17.6866 9.15903C17.6893 9.16147 17.6914 9.16464 17.6926 9.16821C17.6937 9.17177 17.6939 9.1756 17.6931 9.17926C17.6923 9.18293 17.6905 9.1863 17.688 9.18901L16.3184 10.5576L16.6399 12.4958C16.6404 12.4995 16.64 12.5034 16.6385 12.5068C16.6371 12.5103 16.6348 12.5133 16.6318 12.5156C16.6288 12.5178 16.6253 12.5191 16.6216 12.5194C16.6179 12.5197 16.6143 12.5189 16.611 12.5172L14.9134 11.6021L13.2167 12.5172C13.2134 12.5189 13.2097 12.5197 13.206 12.5194C13.2023 12.5191 13.1988 12.5178 13.1958 12.5156C13.1929 12.5133 13.1905 12.5103 13.1891 12.5068C13.1877 12.5034 13.1872 12.4995 13.1877 12.4958L13.5092 10.5576L12.1388 9.18489C12.1363 9.18218 12.1345 9.17881 12.1337 9.17514C12.1329 9.17148 12.1331 9.16765 12.1342 9.16409C12.1354 9.16052 12.1375 9.15735 12.1403 9.15491C12.1431 9.15247 12.1465 9.15087 12.1501 9.15026L14.047 8.86748L14.8949 7.10814C14.8966 7.10466 14.8991 7.10172 14.9023 7.09966C14.9055 7.09761 14.9092 7.09652 14.913 7.09652C14.9168 7.09652 14.9205 7.09761 14.9237 7.09966C14.9269 7.10172 14.9295 7.10466 14.9311 7.10814Z"
      fill="#E9A600"
    />
  </svg>
);
